var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"click":_vm.contentClicked}},[_c('Viewer',{ref:"viewer",staticClass:"markdown-viewer",attrs:{"initial-value":_vm.finalValue,"options":_vm.defaultOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }